module.exports = __webpack_public_path__ + "static/media/ShareLink.9a6fb16e.png";